import * as Fingerprint2 from 'fingerprintjs2';

/**
 * @function
 * @name getFingerprintHash
 * @returns {Promise<string>}
 */
export const getFingerprintHash = async () => {
  /* 실제 사용할 목록
   * language
   * cpuClass
   * platform
   * touchSupport
   */

  const options = {
    excludes: {
      userAgent: true,
      webdriver: true,
      language: false,
      colorDepth: true,
      deviceMemory: true,
      pixelRatio: true,
      hardwareConcurrency: true,
      screenResolution: true,
      availableScreenResolution: true,
      timezoneOffset: true,
      timezone: true,
      sessionStorage: true,
      localStorage: true,
      indexedDb: true,
      addBehavior: true,
      openDatabase: true,
      cpuClass: false,
      platform: false,
      doNotTrack: true,
      plugins: true,
      canvas: true,
      webgl: true,
      webglVendorAndRenderer: true,
      adBlock: true,
      hasLiedLanguages: true,
      hasLiedResolution: true,
      hasLiedOs: true,
      hasLiedBrowser: true,
      touchSupport: false,
      fonts: true,
      fontsFlash: true,
      audio: true,
      enumerateDevices: true,
    },
  };

  try {
    const components = await Fingerprint2.getPromise(options);
    const values = components.map((component) => {
      if (typeof component.value === 'string') return component.value.toUpperCase();
      return component.value;
    });
    return Fingerprint2.x64hash128(values.join(''), 31);
  } catch (e) {
    console.error(e);
  }
};
